import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'antd-v5';
import SearchClientsInput from '../../../../Routes/ProductDetails/Layout/components/SearchClientsInput';

const RelationshipsNew = ({
  handleSaveNewRelationship,
  setShowAddClientForm,
  setNewClient,
  relationship,
  setRelationship,
  setNewRelationship,
  toggleAddClientForm,
}) => {
  return (
    <div className="flex-col-center h-100-P">
      <div className="flex-col-left m-btm-8 w-100-P m-btm-15">
        <div style={{ width: '275px' }} className="align-left">
          {relationship.name ? (
            <div
              style={{ display: 'flex', width: '275px', borderBottom: '1px #818181 solid' }}
              className="flex-row-spacebetween-nowrap"
            >
              <span className="fs-12 fw-500 black">{relationship.name}</span>
              <FontAwesomeIcon
                icon="fa-duotone fa-circle-xmark"
                style={{ '--fa-primary-color': '#6b6b6b', '--fa-secondary-color': '#d1d1d1' }}
                onClick={() => {
                  setRelationship({ ...relationship, name: '' });
                }}
              />
            </div>
          ) : (
            <div>
              {' '}
              <span className="fs-12 fw-500 gray">Add Relationship</span>
              <SearchClientsInput
                onSelect={value => {
                  if (value) {
                    setRelationship(value);
                  }
                }}
                className="cb-send-product-modal__client-input"
                posType
                style={{ margin: '0 0 8px' }}
                placeholder="Search client"
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <Button
                  id="add-client-button"
                  type="link"
                  className="cb-link-btn-action"
                  onClick={toggleAddClientForm}
                >
                  <FontAwesomeIcon icon={['far', 'user-plus']} />
                  Add Client
                </Button>
              </div>{' '}
            </div>
          )}
          <div
            style={{ display: 'flex', width: '275px', borderBottom: '1px #818181 solid' }}
            className="flex-row-spacebetween-nowrap"
          >
            <input
              className="h-29 rem-pad-width mq-50-P-to-100-P-on-535 border-none outline-none m-top-20"
              style={{ width: '100%' }}
              placeholder="Relationship name"
              value={relationship.relationshipName}
              onChange={e => setRelationship({ ...relationship, relationshipName: e.target.value })}
            />
            <FontAwesomeIcon
              className="m-top-20"
              icon="fa-duotone fa-circle-xmark"
              style={{ '--fa-primary-color': '#6b6b6b', '--fa-secondary-color': '#d1d1d1' }}
              onClick={() => {
                setRelationship({ ...relationship, relationshipName: '' });
              }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '15px' }}>
            <Button
              onClick={() => {
                setNewClient({});
                setRelationship({});
                setNewRelationship(false);
                setShowAddClientForm(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!relationship.name || !relationship.relationshipName}
              onClick={() => handleSaveNewRelationship()}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelationshipsNew;
